var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CropRoundedIcon from "@mui/icons-material/CropRounded";
import ZoomInRoundedIcon from "@mui/icons-material/ZoomInRounded";
import { Box, IconButton, Modal, Slider, Typography } from "@mui/material";
import Cropper from "react-easy-crop";
import { ToolbarButton } from "shared";
import { cropImageToFile } from "shared/lib/image";
var ImageCropModal = function (_a) {
    var open = _a.open, imageSrc = _a.imageSrc, aspect = _a.aspect, shape = _a.shape, outputType = _a.outputType, onClose = _a.onClose, onApply = _a.onApply;
    var _b = useState({ x: 0, y: 0 }), crop = _b[0], setCrop = _b[1];
    var _c = useState(1), zoom = _c[0], setZoom = _c[1];
    var _d = useState({ x: 0, y: 0, width: 0, height: 0 }), pixelCrop = _d[0], setPixelCrop = _d[1];
    var _e = useState(false), isApplying = _e[0], setIsApplying = _e[1];
    var onCropComplete = useCallback(function (_, croppedPixels) {
        setPixelCrop(croppedPixels);
    }, []);
    var handleApply = function () { return __awaiter(void 0, void 0, void 0, function () {
        var file, localUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pixelCrop.width)
                        return [2 /*return*/];
                    setIsApplying(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, cropImageToFile(imageSrc, pixelCrop, outputType)];
                case 2:
                    file = _a.sent();
                    localUrl = URL.createObjectURL(file);
                    onApply(file, localUrl);
                    onClose();
                    return [3 /*break*/, 4];
                case 3:
                    setIsApplying(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Modal, { open: open, onClose: onClose, slotProps: {
            backdrop: {
                sx: {
                    background: "rgba(2,4,7,0.82)",
                    backdropFilter: "blur(8px)",
                },
            },
        }, children: _jsx(Box, { sx: {
                position: "fixed",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: "12px", sm: "24px" },
                outline: "none",
            }, onClick: onClose, children: _jsxs(Box, { sx: {
                    width: "100%",
                    maxWidth: 520,
                    borderRadius: "18px",
                    border: "1px solid rgba(255,255,255,0.08)",
                    background: "#0f0f12",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.85)",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                }, onClick: function (e) { return e.stopPropagation(); }, children: [_jsxs(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: "20px",
                            py: "14px",
                            borderBottom: "1px solid rgba(255,255,255,0.07)",
                            flexShrink: 0,
                        }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: "10px" }, children: [_jsx(Box, { sx: {
                                            width: 36,
                                            height: 36,
                                            borderRadius: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "rgba(255,184,1,0.1)",
                                            border: "1px solid rgba(255,184,1,0.18)",
                                        }, children: _jsx(CropRoundedIcon, { sx: { fontSize: 18, color: "rgb(255,184,1)" } }) }), _jsx(Typography, { sx: { fontSize: 15, fontWeight: 600, color: "#fff", fontFamily: "var(--default-font)", lineHeight: 1 }, children: outputType === "avatar" ? "Crop Avatar" : "Crop Banner" })] }), _jsx(IconButton, { onClick: onClose, sx: {
                                    width: 32,
                                    height: 32,
                                    borderRadius: "8px",
                                    color: "rgba(255,255,255,0.4)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    backgroundColor: "rgba(255,255,255,0.04)",
                                    "&:hover": { color: "#fff", backgroundColor: "rgba(255,255,255,0.08)" },
                                }, children: _jsx(CloseRoundedIcon, { sx: { fontSize: 16 } }) })] }), _jsx(Box, { sx: {
                            position: "relative",
                            width: "100%",
                            height: outputType === "avatar" ? 340 : 260,
                            background: "#060608",
                        }, children: _jsx(Cropper, { image: imageSrc, crop: crop, zoom: zoom, aspect: aspect, cropShape: shape, showGrid: shape === "rect", onCropChange: setCrop, onZoomChange: setZoom, onCropComplete: onCropComplete, style: {
                                containerStyle: { background: "#060608" },
                                cropAreaStyle: {
                                    border: "2px solid rgb(255,184,1)",
                                    boxShadow: "0 0 0 9999px rgba(0,0,0,0.62)",
                                },
                            } }) }), _jsxs(Box, { sx: {
                            px: "20px",
                            pt: "16px",
                            pb: "4px",
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            borderTop: "1px solid rgba(255,255,255,0.07)",
                        }, children: [_jsx(ZoomInRoundedIcon, { sx: { fontSize: 18, color: "rgba(255,255,255,0.35)", flexShrink: 0 } }), _jsx(Slider, { value: zoom, min: 1, max: 3, step: 0.01, onChange: function (_, v) { return setZoom(v); }, sx: {
                                    color: "rgb(255,184,1)",
                                    "& .MuiSlider-thumb": {
                                        width: 14,
                                        height: 14,
                                        "&:hover, &.Mui-focusVisible": { boxShadow: "0 0 0 6px rgba(255,184,1,0.18)" },
                                    },
                                    "& .MuiSlider-rail": { opacity: 0.22 },
                                } }), _jsxs(Typography, { sx: { fontSize: 11, color: "rgba(255,255,255,0.35)", fontFamily: "var(--default-font)", minWidth: 32, textAlign: "right" }, children: [zoom.toFixed(1), "\u00D7"] })] }), _jsxs(Box, { sx: {
                            display: "flex",
                            gap: "8px",
                            px: "20px",
                            pb: "18px",
                            pt: "12px",
                        }, children: [_jsx(ToolbarButton, { onClick: onClose, sx: {
                                    height: 38,
                                    px: "18px",
                                    borderRadius: "10px",
                                    fontSize: 13,
                                    fontWeight: 500,
                                    fontFamily: "var(--default-font)",
                                }, children: "Cancel" }), _jsx(ToolbarButton, { onClick: handleApply, disabled: isApplying, active: true, sx: {
                                    flex: 1,
                                    height: 38,
                                    borderRadius: "10px",
                                    fontSize: 13,
                                    fontWeight: 600,
                                    fontFamily: "var(--default-font)",
                                    color: "#0a0800",
                                    backgroundColor: "rgb(255,184,1)",
                                    border: "1px solid rgb(255,184,1)",
                                    "&:hover": { backgroundColor: "rgb(255,200,50)", boxShadow: "0 4px 16px rgba(255,184,1,0.28)" },
                                    "&.Mui-disabled": { backgroundColor: "rgba(255,255,255,0.06)", borderColor: "rgba(255,255,255,0.07)", color: "rgba(255,255,255,0.22)" },
                                }, children: isApplying ? "Applying..." : "Apply" })] })] }) }) }));
};
export default ImageCropModal;
